export default __webpack_public_path__ + "static/media/mutation-teller.63ccdfd0.png";